import { render } from "./MainFooter.vue?vue&type=template&id=fb44bb90&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=fb44bb90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb44bb90"]])

export default __exports__